import { mdiArrowExpand } from '@mdi/js'
import Icon from '@mdi/react'
import { useAtom } from 'jotai'

import Body from '@/components/body/Body'
import { Box } from '@/components/ui/box'
import { Container } from '@/components/ui/container'
import { Flex } from '@/components/ui/flex'
import useColorModeValue from '@/hooks/useColorModeValue'
import useCustomMediaQuery from '@/hooks/useCustomMediaQuery'
import ItemsTabs from '@/pages/components/tasksApprovals/mainContent/tabs'
import { isExpandedAtom } from '@/store/tasksApprovals'

import DetailsDrawer from './components/tasksApprovals/detailsDrawer'
import WidgetList from './components/tasksApprovals/widgets'
import MobileDrawer from './components/tasksApprovals/widgets/mobileDrawer'

const TasksApprovals = () => {
    const [isExpanded, setIsExpanded] = useAtom(isExpandedAtom)
    const [isMobile] = useCustomMediaQuery()

    const toggleWidget = () => {
        setIsExpanded(!isExpanded)
    }

    return (
        <>
            <Container
                maxW="100%"
                display="flex"
                flexDirection="column"
                flexGrow="1"
                flexShrink="1"
                overflow="hidden"
                padding="0"
                backgroundColor={useColorModeValue('var(--chakra-colors-surface-light)', 'black')}
            >
                <Body>
                    <Box
                        flex={1}
                        mt="16px"
                        mr={['8px', '8px', '16px']}
                        p={['16px 0 0 16px', '16px 0 0 16px', '16px 0 0 24px']}
                        borderRadius="0 8px"
                        boxShadow="0px 0px 8px 1px rgba(84, 79, 64, 0.06)"
                        borderLeft="0"
                        backgroundColor={useColorModeValue('var(--chakra-colors-white)', 'var(--chakra-colors-dark-900)')}
                    >
                        <ItemsTabs />
                    </Box>
                    <Flex
                        display={isExpanded ? 'none' : 'flex'}
                        flex={1}
                        direction="column"
                        alignItems={['center', 'center', 'center', 'normal']}
                        maxWidth={['60px', '60px', '60px', '300px']}
                        maxHeight="100%"
                        overflow="auto"
                        scrollbarGutter="stable"
                        mt="12px"
                        backgroundColor={useColorModeValue('var(--chakra-colors-surface-light)', 'black')}
                    >
                        <Flex
                            justifyContent="center"
                            flexDir="row"
                            p="8px"
                            hideFrom="lg"
                            minW="52px"
                            onClick={toggleWidget}
                            cursor="pointer"
                        >
                            <Icon path={mdiArrowExpand} size="22px" />
                        </Flex>
                        <WidgetList isExpanded={!isMobile} />
                        <MobileDrawer />
                    </Flex>
                </Body>
            </Container>
            <DetailsDrawer />
        </>
    )
}

export default TasksApprovals
